module.exports = __webpack_public_path__ + "img/arte.e28f6d04.svg";